import React, { FC } from 'react';

import { useRatingQuery } from '@/api/getters';
import Badge from '@/components/Badge';
import cn from '@/utils/cn';

import { Trans } from '@lingui/react';

interface Props {
  className?: string;
}

const Opinion: FC<Props> = ({ className }) => {
  const { data } = useRatingQuery();

  return (
    <div
      className={cn(
        'flex w-full flex-col items-center gap-2 rounded-md bg-gray-200 p-4',
        className
      )}
    >
      <p className="caption text-center text-dark-gray-500">
        <Trans id="Klienci oceniają nas bardzo pozytywnie"></Trans>{' '}
      </p>
      <Badge
        variant={'gray'}
        google={
          data?.google ?? {
            count: 1022,
            rate: 4.4,
          }
        }
      />
      <Badge variant={'padlock'} />
    </div>
  );
};

export default Opinion;
